const area = "w-full border-2 border-[#D3CFC0] bg-white p-2 text-sm leading-relaxed focus:border-[#1E1E1E] outline-none";
const label = "block text-[10px] uppercase font-[IBM_Plex_Mono] text-[#6E6E6E] mb-1";

function Notes({ name, value, onChange }) {
  const v = value || {};
  return (
    <div className="grid md:grid-cols-3 gap-2">
      {[["say_this", "Say this"], ["watch_for", "Watch for"], ["if_bored", "If they're bored"]].map(([k, l]) => (
        <div key={k}>
          <label className={label}>{l}</label>
          <textarea data-testid={`sk-field-${name}-${k}`} rows={3} className={area} value={v[k] || ""}
            onChange={(e) => onChange({ ...v, [k]: e.target.value })} />
        </div>
      ))}
    </div>
  );
}

function Scenarios({ name, value, onChange }) {
  const list = value || [];
  const upd = (i, k, val) => onChange(list.map((s, j) => (j === i ? { ...s, [k]: val } : s)));
  return (
    <div className="space-y-2">
      {list.map((s, i) => (
        <div key={i} className="border border-[#D3CFC0] p-2 bg-white">
          <input data-testid={`sk-field-${name}-${i}-situation`} className={`${area} mb-1 font-semibold`} value={s.situation} onChange={(e) => upd(i, "situation", e.target.value)} />
          <textarea data-testid={`sk-field-${name}-${i}-script`} rows={4} className={area} value={s.script} onChange={(e) => upd(i, "script", e.target.value)} />
        </div>
      ))}
    </div>
  );
}

export default function FieldEditor({ name, kind, value, onChange }) {
  const title = name.replace(/_/g, " ");
  return (
    <div>
      <label className={label}>{title}{kind === "list" ? " (one per line)" : ""}</label>
      {kind === "str" && (
        <textarea data-testid={`sk-field-${name}`} rows={name === "body" ? 10 : name === "title" ? 1 : 3}
          className={area} value={value || ""} onChange={(e) => onChange(e.target.value)} />
      )}
      {kind === "list" && (
        <textarea data-testid={`sk-field-${name}`} rows={Math.max(3, (value || []).length + 1)} className={area}
          value={(value || []).join("\n")} onChange={(e) => onChange(e.target.value.split("\n"))} />
      )}
      {kind === "notes" && <Notes name={name} value={value} onChange={onChange} />}
      {kind === "scenarios" && <Scenarios name={name} value={value} onChange={onChange} />}
    </div>
  );
}
